/*
  eslint
  react/no-string-refs: off
*/
import React, { PropTypes, PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { hashHistory } from 'react-router';
import { Button } from '../shared';
import messages from './i18n';
import statsd from '../../../lib/StatsD';
import styles from './styles.scss';

export class SignUpWelcome extends PureComponent {
  static propTypes = {
    signUpSetSteps: PropTypes.func,
  };

  static onGetStartedClick() {
    setTimeout(() => {
      hashHistory.push('/user');
    }, 250);
  }

  constructor(props) {
    super(props);
    this.state = { fadeOut: false };
  }


  addAnimationClass() {
    this.setState({ fadeOut: true });
  }


  render() {
    return (
      <div
        className={styles.view}
      >
        <div className={cn(styles.layout, { [styles.fadeAndScaleOut]: this.state.fadeOut })}>

          <div className={styles.container}>
            <div className={styles.image_container}>
              {/* eslint-disable */}
              <img className={styles.gif} src={require('./signup_splash_desktop_tablet.png')} alt="process" />
              {/* eslint-enable */}

              <div className={styles.caption}>
                <h3><FormattedMessage {...messages.title} /></h3>
                <p><FormattedMessage {...messages.subtitle} /></p>
              </div>
            </div>
            <div className={styles.options}>
              <Button
                className={styles.signUp}
                onClick={() => { SignUpWelcome.onGetStartedClick(); this.addAnimationClass(); }}
                label={this.props.intl.formatMessage(messages.getStarted)}
                primary
              />

              <div className={styles.logIn}>
                <p
                  onClick={() => {
                    statsd.increment('logIn.start');
                    hashHistory.push('/setup');
                  }}
                >
                  <FormattedMessage {...messages.existingAccount} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SignUpWelcome);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_welcome/index.jsx